import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const reposFinderAppBuilder = DataRouterApplicationBuilder.create('repos-finder')
